import React from "react";
import CKServiceApp from "./App";
import "./styles.css";
import { useMatchMedia } from "./pages/useMatchMedia";
import { Helmet } from "react-helmet";

/**
 * Render react app with redux store
 */

const CKService: React.FC = () => {
  const isDesktopResolution = useMatchMedia("(min-width:992px)", true);
  return (
    <React.Fragment>
      <Helmet>
        <meta charSet="utf-8" />
        <title>MBA Services</title>
      </Helmet>
      <CKServiceApp isDesktopResolution={isDesktopResolution} />
    </React.Fragment>
  );
};

export default CKService;
